/**
 * FILE: packages/supabase/src/edgeFunctions.ts
 * PURPOSE: Injectable edge-function invocation seam for service-layer code.
 * AGENT_CONTEXT: Services should accept an EdgeFunctionInvoker parameter defaulting to defaultEdgeFunctionInvoker instead of importing supabase directly.
 */

import type { SupabaseClient } from '@supabase/supabase-js'
import { supabase } from './client'
import type { Database } from './types'

export type EdgeFunctionInvoker = SupabaseClient<Database>['functions']['invoke']

export const defaultEdgeFunctionInvoker: EdgeFunctionInvoker = (
  name: string,
  ...args: Parameters<EdgeFunctionInvoker> extends [string, ...infer Rest] ? Rest : never[]
) => supabase.functions.invoke(name, ...(args as [NonNullable<Parameters<EdgeFunctionInvoker>[1]>]))
